import { Box, Checkbox, FormControlLabel, Grid } from "@mui/material";
import Text from "../../../../../../../../components/Text";

type AssessmentLegendCheckBoxesProps = {
  options: Record<
    string,
    { color: string; label: string; maxScore: number; totalQuestions: number }
  >;
  selectedAssessments: Record<string, boolean>;
  toggleAssessment: (name: string) => void;
};

const AssessmentLegendCheckBoxes = ({
  options,
  selectedAssessments,
  toggleAssessment,
}: AssessmentLegendCheckBoxesProps) => {
  return (
    <Grid container spacing={2}>
      {Object.entries(options ?? {}).map(([name, config]) => (
        <Grid item xs={12} sm={4} md={3} lg={2} key={name}>
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedAssessments[name] ?? false}
                onChange={() => toggleAssessment(name)}
                size="small"
              />
            }
            label={
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                      backgroundColor: config.color,
                    }}
                  />
                  <Text variant="body2">{name}</Text>
                </Box>
                {/* <Text color="text.secondary" sx={{ ml: 2.5 }}>
                  {config.label}
                </Text> */}
              </Box>
            }
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AssessmentLegendCheckBoxes;
